module.exports = __webpack_public_path__ + "static/media/opex-instruction-logo.d4754a74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/opex-instruction-logo.svg
// module id = 2430
// module chunks = 7